import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBellFilled = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 16,
	viewBox: "0 0 14 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7 16C8.09375 16 9 15.125 9 14H5C5 15.125 5.875 16 7 16ZM13.7188 11.3438C13.125 10.6875 11.9688 9.71875 11.9688 6.5C11.9688 4.09375 10.2812 2.15625 8 1.65625V1C8 0.46875 7.53125 0 7 0C6.4375 0 6 0.46875 6 1V1.65625C3.6875 2.15625 2 4.09375 2 6.5C2 9.71875 0.84375 10.6875 0.25 11.3438C0.0625 11.5312 0 11.7812 0 12C0 12.5312 0.40625 13 1 13H12.9688C13.5938 13 13.9688 12.5312 14 12C14 11.7812 13.9062 11.5312 13.7188 11.3438Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgBellFilled);
export { ForwardRef as ReactComponent };
